// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS for Header component */ 
.shop-header {
    background-color: #222;
    color: white;
    transition: transform 0.3s ease-in-out;
    width: 100%;
    z-index: 998;
    position: relative;
    box-sizing: border-box;
}

.shop-header.scrolled {
    position: fixed;
    top: 0;
    left: 0;
    transform: translateY(0);
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.header-placeholder {
    height: 218px; /* .top-bar (140px) + .bottom-nav (78px) */
}

.top-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 40px;
    height: 140px;
    box-sizing: border-box;
    width: 100%;
    margin: 0;
}

/* Desktop max-width for inner content */
@media (min-width: 1025px) {
    .top-bar {
        max-width: 1430px;
        margin: 0 auto;
    }
    
    .bottom-nav-inner {
        max-width: 1430px;
        margin: 0 auto;
    }
}

.logo-container .logo {
    height: 83px; /* From JSON */
}

.search-container {
    display: flex;
    border: 2px solid #E84100;
    border-radius: 12px;
    background-color: #1c1b1f;
    width: 423px;
    height: 53px;
    overflow: hidden;
}

.search-form {
    display: flex;
    width: 100%;
    height: 100%;
}

.search-input {
    flex: 0 0 80%;
    border: none;
    background: transparent;
    color: white;
    padding: 0 15px;
    font-size: 16px;
}

.search-input:focus {
    outline: none;
}

.search-button {
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0 15px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.search-icon {
    width: 31px;
    height: 30px;
    object-fit: contain;
}

.side-actions {
    display: flex;
    align-items: center;
    gap: 30px;
    flex-shrink: 0;
    position: relative;
}

.contact-info {
    display: flex;
    align-items: center;
    gap: 15px;
    background: none !important;
    background-color: transparent !important;
    border: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
}

.contact-info p {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
    color: white !important;
}

.contact-info .phone-number {
    font-size: 20px;
    font-weight: bold;
    color: white !important;
}

.support-icon {
    display: flex;
    align-items: center;
    justify-content: center;
}

.support-icon-img {
    width: 30px;
    height: 30px;
    object-fit: contain;
}

.user-actions {
    display: flex;
    gap: 25px;
    align-items: center;
    flex-shrink: 0;
    position: relative;
    z-index: 10;
}

.action-item {
    text-align: center;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 60px;
    padding: 5px;
    position: relative;
    z-index: 11;
    pointer-events: auto;
    -webkit-user-select: none;
            user-select: none;
}

.action-item p {
    margin-top: 6px;
    margin-bottom: 0;
    font-size: 14px;
    white-space: nowrap;
}

.icon-wrapper {
    position: relative;
    width: 30px;
    height: 30px;
    margin: 0 auto;
}

.icon-wrapper svg,
.icon-wrapper img {
    width: 30px;
    height: 30px;
    object-fit: contain;
}

.cart-icon,
.user-icon {
    width: 30px;
    height: 30px;
    object-fit: contain;
}

.cart-count {
    position: absolute;
    top: -5px;
    right: -8px;
    background-color: #E84100;
    color: white;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
}

.bottom-nav {
    background-color: #E84100;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    height: 78px;
    width: 100%;
    box-sizing: border-box;
    position: relative;
}

.bottom-nav-inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0 40px;
    box-sizing: border-box;
}

.nav-links {
    display: flex;
    align-items: center;
    gap: 68px;
}

.nav-link {
    color: white;
    text-decoration: none;
    padding: 0 15px;
    font-size: 16px;
    border-bottom: 3px solid transparent;
    transition: all 0.3s ease;
}

.nav-link:hover,
.nav-link.active {
    border-bottom: 3px solid #E84100;
}

.nav-home-link {
    padding: 0 15px;
    border-bottom: 3px solid transparent;
    transition: all 0.3s ease;
}

.nav-home-link:hover,
.nav-home-link.active {
    border-bottom: 3px solid #E84100;
}

.nav-links a:hover {
    color: #FFFFFF !important;
}

.nav-home-link svg,
.home-icon {
    width: 24px;
    height: 24px;
    object-fit: contain;
}

.all-products-btn {
    background-color: #222;
    color: white;
    border: none;
    border-radius: 10px;
    padding: 12px 20px;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: background-color 0.2s ease-in-out;
}

.all-products-btn:hover {
    background-color: #444;
}

.all-products-btn svg,
.arrow-down-icon {
    width: 24px;
    height: 24px;
    object-fit: contain;
}

/* For mobile menu functionality */
.mobile-menu-icon {
    display: none;
    background: none;
    border: none;
    cursor: pointer;
}

.mobile-header-actions {
    display: none;
}

.mobile-nav-menu {
    display: none;
}

.mobile-side-menu {
    height: 100vh;
    width: 280px;
    position: fixed;
    top: 0;
    right: 0;
    background-color: #fff;
    z-index: 1000;
    transform: translateX(100%);
    transition: transform 0.3s ease-in-out;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.mobile-side-menu.open {
    transform: translateX(0);
}

.mobile-side-menu .nav-link {
    color: #333;
    font-size: 16px;
    text-decoration: none;
}

.close-menu-btn {
    background: none;
    border: none;
    color: #333;
    font-size: 24px;
    align-self: flex-start;
    cursor: pointer;
}

.mobile-menu-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
}

/* Category Popup Styles */
.category-popup-overlay {
    position: fixed;
    top: 218px; /* Below header */
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
}

.category-popup {
    position: fixed;
    top: 218px; /* Below header */
    left: 0;
    right: 0;
    background-color: #f8f8f8;
    z-index: 1000;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    border-top: 3px solid #E84100;
}

.category-grid-container {
    width: 100%;
    margin: 0;
    padding: 0;
    overflow-x: auto;
    scrollbar-width: thin;
    scrollbar-color: #E84100 #f0f0f0;
    background-color: #f8f8f8;
}

.category-grid {
    display: flex;
    width: 100%;
    min-width: 100%;
    padding: 0;
    background-color: #f8f8f8;
    align-items: stretch;
}

/* When there are 6 or fewer categories, fill the width */
.category-grid.few-categories {
    width: 100%;
}

.category-grid.few-categories .category-item {
    flex: 1 1;
    min-width: 200px;
    height: auto;
}

/* When there are more than 6 categories, allow horizontal scroll */
.category-grid.many-categories {
    min-width: max-content;
}

.category-grid.many-categories .category-item {
    flex: none;
    min-width: 200px;
}

.category-item {
    min-height: 400px;
    height: auto;
    cursor: pointer;
    transition: all 0.3s ease;
    border-right: 1px solid #ddd;
    background-color: #f8f8f8;
    color: #333;
    display: flex;
    flex-direction: column;
}

.category-item:hover,
.category-item.active {
    background: linear-gradient(135deg, #E84100 0%, #d63900 100%) !important;
    color: white !important;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.category-item:last-child {
    border-right: none;
}

.category-content {
    padding: 30px 25px;
    height: auto;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    background-color: inherit;
    flex: 1 1;
}

.category-item:hover .category-content,
.category-item.active .category-content {
    background-color: transparent;
}

.category-content h3 {
    font-size: 24px;
    font-weight: bold;
    margin: 0 0 20px 0;
    text-align: center;
}

.category-label {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 15px;
    text-align: center;
    padding-bottom: 10px;
    border-bottom: 1px solid #ddd;
}

.category-item:hover .category-label,
.category-item.active .category-label {
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}

.category-items {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 20px;
    flex: 1 1;
    background-color: inherit;
    overflow: visible;
}

.category-spec {
    font-size: 14px;
    padding: 8px 0;
    text-align: center;
    transition: all 0.2s ease;
    background: transparent;
    border: none;
    border-bottom: 2px solid transparent;
    cursor: pointer;
}

.category-item:hover .category-spec,
.category-item.active .category-spec {
    color: white;
    background: transparent;
    border: none;
    border-bottom: 2px solid transparent;
}

.category-item:hover .category-spec:hover,
.category-item.active .category-spec:hover {
    background: transparent;
    border-bottom: 2px solid white;
}

.category-spec:hover {
    background: transparent;
    border-bottom: 2px solid #ddd;
}

.product-count {
    font-size: 12px;
    opacity: 0.8;
    font-weight: normal;
}

/* Responsive adjustments for category popup */
@media (max-width: 768px) {
    .category-popup {
        top: 60px; /* Mobile header height */
    }
    
    .category-grid-container {
        padding: 0;
    }
    
    .category-grid {
        padding: 0 10px;
    }
    
    .category-item {
        min-width: 160px;
        height: 300px;
    }
    
    .category-content {
        padding: 20px 15px;
    }
    
    .category-content h3 {
        font-size: 18px;
        margin-bottom: 15px;
    }
    
    .category-spec {
        font-size: 12px;
        padding: 6px 0;
    }
    
    /* Mobile hover effects */
    .category-item:active,
    .category-item.active {
        background: linear-gradient(135deg, #E84100 0%, #d63900 100%) !important;
        color: white !important;
    }
    
    .category-item:active .category-label,
    .category-item.active .category-label {
        border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    }
    
    .category-item:active .category-spec,
    .category-item.active .category-spec {
        color: white;
        background: transparent;
        border: none;
        border-bottom: 2px solid transparent;
    }
    
    .category-item:active .category-spec:active,
    .category-item.active .category-spec:active {
        border-bottom: 2px solid white;
    }
}

/* Tablet and smaller devices */
@media (max-width: 1024px) {
    .top-bar {
        height: auto;
        gap: 20px;
        padding: 20px;
    }

    .search-container {
        width: 100%;
        max-width: 500px;
    }

    .side-actions {
        width: 100%;
        justify-content: space-between;
    }

    .bottom-nav {
        padding: 0 20px;
    }

    .nav-links {
        gap: 30px;
    }
}

/* Mobile devices */
@media (max-width: 768px) {
    .top-bar {
        justify-content: space-between;
        align-items: center;
        height: 60px;
        padding: 0 15px;
    }

    .logo-container .logo {
        height: 24px;
    }

    .search-container, .side-actions, .bottom-nav {
        display: none;
    }
    
    .mobile-header-actions {
        display: flex;
        align-items: center;
        gap: 15px;
    }

    .mobile-header-actions .action-item {
        min-height: auto;
        padding: 0;
        flex-direction: row;
    }

    .mobile-header-actions .icon-wrapper {
        width: 24px;
        height: 24px;
    }

    .mobile-header-actions .icon-wrapper svg,
    .mobile-header-actions .icon-wrapper img {
        width: 24px;
        height: 24px;
    }

    .mobile-menu-icon {
        display: block;
    }
    
    .mobile-menu-icon svg,
    .more-vert-icon {
        width: 24px;
        height: 24px;
        object-fit: contain;
    }

    .mobile-nav-menu {
        display: none;
    }

    .header-placeholder {
        height: 60px; /* mobile header height */
    }
} `, "",{"version":3,"sources":["webpack://./src/components/css/Header.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;IACI,sBAAsB;IACtB,YAAY;IACZ,sCAAsC;IACtC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,wBAAwB;IACxB,sCAAsC;AAC1C;;AAEA;IACI,aAAa,EAAE,0CAA0C;AAC7D;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,SAAS;AACb;;AAEA,wCAAwC;AACxC;IACI;QACI,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,iBAAiB;QACjB,cAAc;IAClB;AACJ;;AAEA;IACI,YAAY,EAAE,cAAc;AAChC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,2BAA2B;IAC3B,wCAAwC;IACxC,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,6CAA6C;AACjD;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA,kCAAkC;AAClC;IACI,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,eAAe;IACf,MAAM;IACN,QAAQ;IACR,sBAAsB;IACtB,aAAa;IACb,2BAA2B;IAC3B,sCAAsC;IACtC,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,YAAY;AAChB;;AAEA,0BAA0B;AAC1B;IACI,eAAe;IACf,UAAU,EAAE,iBAAiB;IAC7B,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,UAAU,EAAE,iBAAiB;IAC7B,OAAO;IACP,QAAQ;IACR,yBAAyB;IACzB,aAAa;IACb,0CAA0C;IAC1C,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,qBAAqB;IACrB,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,eAAe;IACf,UAAU;IACV,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA,yDAAyD;AACzD;IACI,WAAW;AACf;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,YAAY;AAChB;;AAEA,mEAAmE;AACnE;IACI,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,4BAA4B;IAC5B,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;;IAEI,wEAAwE;IACxE,uBAAuB;IACvB,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,SAAO;AACX;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;;IAEI,iDAAiD;AACrD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,SAAO;IACP,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,uBAAuB;IACvB,YAAY;IACZ,oCAAoC;IACpC,eAAe;AACnB;;AAEA;;IAEI,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,oCAAoC;AACxC;;AAEA;;IAEI,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;AACvB;;AAEA,8CAA8C;AAC9C;IACI;QACI,SAAS,EAAE,yBAAyB;IACxC;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA,yBAAyB;IACzB;;QAEI,wEAAwE;QACxE,uBAAuB;IAC3B;;IAEA;;QAEI,iDAAiD;IACrD;;IAEA;;QAEI,YAAY;QACZ,uBAAuB;QACvB,YAAY;QACZ,oCAAoC;IACxC;;IAEA;;QAEI,8BAA8B;IAClC;AACJ;;AAEA,+BAA+B;AAC/B;IACI;QACI,YAAY;QACZ,SAAS;QACT,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,8BAA8B;IAClC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,8BAA8B;QAC9B,mBAAmB;QACnB,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,gBAAgB;QAChB,UAAU;QACV,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;;QAEI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY,EAAE,yBAAyB;IAC3C;AACJ","sourcesContent":["/* CSS for Header component */ \n.shop-header {\n    background-color: #222;\n    color: white;\n    transition: transform 0.3s ease-in-out;\n    width: 100%;\n    z-index: 998;\n    position: relative;\n    box-sizing: border-box;\n}\n\n.shop-header.scrolled {\n    position: fixed;\n    top: 0;\n    left: 0;\n    transform: translateY(0);\n    box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n}\n\n.header-placeholder {\n    height: 218px; /* .top-bar (140px) + .bottom-nav (78px) */\n}\n\n.top-bar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px 40px;\n    height: 140px;\n    box-sizing: border-box;\n    width: 100%;\n    margin: 0;\n}\n\n/* Desktop max-width for inner content */\n@media (min-width: 1025px) {\n    .top-bar {\n        max-width: 1430px;\n        margin: 0 auto;\n    }\n    \n    .bottom-nav-inner {\n        max-width: 1430px;\n        margin: 0 auto;\n    }\n}\n\n.logo-container .logo {\n    height: 83px; /* From JSON */\n}\n\n.search-container {\n    display: flex;\n    border: 2px solid #E84100;\n    border-radius: 12px;\n    background-color: #1c1b1f;\n    width: 423px;\n    height: 53px;\n    overflow: hidden;\n}\n\n.search-form {\n    display: flex;\n    width: 100%;\n    height: 100%;\n}\n\n.search-input {\n    flex: 0 0 80%;\n    border: none;\n    background: transparent;\n    color: white;\n    padding: 0 15px;\n    font-size: 16px;\n}\n\n.search-input:focus {\n    outline: none;\n}\n\n.search-button {\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    padding: 0 15px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.search-icon {\n    width: 31px;\n    height: 30px;\n    object-fit: contain;\n}\n\n.side-actions {\n    display: flex;\n    align-items: center;\n    gap: 30px;\n    flex-shrink: 0;\n    position: relative;\n}\n\n.contact-info {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    background: none !important;\n    background-color: transparent !important;\n    border: none !important;\n    border-radius: 0 !important;\n    box-shadow: none !important;\n}\n\n.contact-info p {\n    margin: 0;\n    font-size: 14px;\n    line-height: 1.5;\n    color: white !important;\n}\n\n.contact-info .phone-number {\n    font-size: 20px;\n    font-weight: bold;\n    color: white !important;\n}\n\n.support-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.support-icon-img {\n    width: 30px;\n    height: 30px;\n    object-fit: contain;\n}\n\n.user-actions {\n    display: flex;\n    gap: 25px;\n    align-items: center;\n    flex-shrink: 0;\n    position: relative;\n    z-index: 10;\n}\n\n.action-item {\n    text-align: center;\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 60px;\n    padding: 5px;\n    position: relative;\n    z-index: 11;\n    pointer-events: auto;\n    user-select: none;\n}\n\n.action-item p {\n    margin-top: 6px;\n    margin-bottom: 0;\n    font-size: 14px;\n    white-space: nowrap;\n}\n\n.icon-wrapper {\n    position: relative;\n    width: 30px;\n    height: 30px;\n    margin: 0 auto;\n}\n\n.icon-wrapper svg,\n.icon-wrapper img {\n    width: 30px;\n    height: 30px;\n    object-fit: contain;\n}\n\n.cart-icon,\n.user-icon {\n    width: 30px;\n    height: 30px;\n    object-fit: contain;\n}\n\n.cart-count {\n    position: absolute;\n    top: -5px;\n    right: -8px;\n    background-color: #E84100;\n    color: white;\n    border-radius: 50%;\n    width: 20px;\n    height: 20px;\n    font-size: 12px;\n    line-height: 20px;\n    text-align: center;\n}\n\n.bottom-nav {\n    background-color: #E84100;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0;\n    height: 78px;\n    width: 100%;\n    box-sizing: border-box;\n    position: relative;\n}\n\n.bottom-nav-inner {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding: 0 40px;\n    box-sizing: border-box;\n}\n\n.nav-links {\n    display: flex;\n    align-items: center;\n    gap: 68px;\n}\n\n.nav-link {\n    color: white;\n    text-decoration: none;\n    padding: 0 15px;\n    font-size: 16px;\n    border-bottom: 3px solid transparent;\n    transition: all 0.3s ease;\n}\n\n.nav-link:hover,\n.nav-link.active {\n    border-bottom: 3px solid #E84100;\n}\n\n.nav-home-link {\n    padding: 0 15px;\n    border-bottom: 3px solid transparent;\n    transition: all 0.3s ease;\n}\n\n.nav-home-link:hover,\n.nav-home-link.active {\n    border-bottom: 3px solid #E84100;\n}\n\n.nav-links a:hover {\n    color: #FFFFFF !important;\n}\n\n.nav-home-link svg,\n.home-icon {\n    width: 24px;\n    height: 24px;\n    object-fit: contain;\n}\n\n.all-products-btn {\n    background-color: #222;\n    color: white;\n    border: none;\n    border-radius: 10px;\n    padding: 12px 20px;\n    font-size: 18px;\n    font-weight: bold;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    transition: background-color 0.2s ease-in-out;\n}\n\n.all-products-btn:hover {\n    background-color: #444;\n}\n\n.all-products-btn svg,\n.arrow-down-icon {\n    width: 24px;\n    height: 24px;\n    object-fit: contain;\n}\n\n/* For mobile menu functionality */\n.mobile-menu-icon {\n    display: none;\n    background: none;\n    border: none;\n    cursor: pointer;\n}\n\n.mobile-header-actions {\n    display: none;\n}\n\n.mobile-nav-menu {\n    display: none;\n}\n\n.mobile-side-menu {\n    height: 100vh;\n    width: 280px;\n    position: fixed;\n    top: 0;\n    right: 0;\n    background-color: #fff;\n    z-index: 1000;\n    transform: translateX(100%);\n    transition: transform 0.3s ease-in-out;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.mobile-side-menu.open {\n    transform: translateX(0);\n}\n\n.mobile-side-menu .nav-link {\n    color: #333;\n    font-size: 16px;\n    text-decoration: none;\n}\n\n.close-menu-btn {\n    background: none;\n    border: none;\n    color: #333;\n    font-size: 24px;\n    align-self: flex-start;\n    cursor: pointer;\n}\n\n.mobile-menu-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    z-index: 999;\n}\n\n/* Category Popup Styles */\n.category-popup-overlay {\n    position: fixed;\n    top: 218px; /* Below header */\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    z-index: 999;\n}\n\n.category-popup {\n    position: fixed;\n    top: 218px; /* Below header */\n    left: 0;\n    right: 0;\n    background-color: #f8f8f8;\n    z-index: 1000;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n    border-top: 3px solid #E84100;\n}\n\n.category-grid-container {\n    width: 100%;\n    margin: 0;\n    padding: 0;\n    overflow-x: auto;\n    scrollbar-width: thin;\n    scrollbar-color: #E84100 #f0f0f0;\n    background-color: #f8f8f8;\n}\n\n.category-grid {\n    display: flex;\n    width: 100%;\n    min-width: 100%;\n    padding: 0;\n    background-color: #f8f8f8;\n    align-items: stretch;\n}\n\n/* When there are 6 or fewer categories, fill the width */\n.category-grid.few-categories {\n    width: 100%;\n}\n\n.category-grid.few-categories .category-item {\n    flex: 1;\n    min-width: 200px;\n    height: auto;\n}\n\n/* When there are more than 6 categories, allow horizontal scroll */\n.category-grid.many-categories {\n    min-width: max-content;\n}\n\n.category-grid.many-categories .category-item {\n    flex: none;\n    min-width: 200px;\n}\n\n.category-item {\n    min-height: 400px;\n    height: auto;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    border-right: 1px solid #ddd;\n    background-color: #f8f8f8;\n    color: #333;\n    display: flex;\n    flex-direction: column;\n}\n\n.category-item:hover,\n.category-item.active {\n    background: linear-gradient(135deg, #E84100 0%, #d63900 100%) !important;\n    color: white !important;\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.category-item:last-child {\n    border-right: none;\n}\n\n.category-content {\n    padding: 30px 25px;\n    height: auto;\n    min-height: 100%;\n    display: flex;\n    flex-direction: column;\n    background-color: inherit;\n    flex: 1;\n}\n\n.category-item:hover .category-content,\n.category-item.active .category-content {\n    background-color: transparent;\n}\n\n.category-content h3 {\n    font-size: 24px;\n    font-weight: bold;\n    margin: 0 0 20px 0;\n    text-align: center;\n}\n\n.category-label {\n    font-size: 16px;\n    font-weight: 600;\n    margin-bottom: 15px;\n    text-align: center;\n    padding-bottom: 10px;\n    border-bottom: 1px solid #ddd;\n}\n\n.category-item:hover .category-label,\n.category-item.active .category-label {\n    border-bottom: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.category-items {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-top: 20px;\n    flex: 1;\n    background-color: inherit;\n    overflow: visible;\n}\n\n.category-spec {\n    font-size: 14px;\n    padding: 8px 0;\n    text-align: center;\n    transition: all 0.2s ease;\n    background: transparent;\n    border: none;\n    border-bottom: 2px solid transparent;\n    cursor: pointer;\n}\n\n.category-item:hover .category-spec,\n.category-item.active .category-spec {\n    color: white;\n    background: transparent;\n    border: none;\n    border-bottom: 2px solid transparent;\n}\n\n.category-item:hover .category-spec:hover,\n.category-item.active .category-spec:hover {\n    background: transparent;\n    border-bottom: 2px solid white;\n}\n\n.category-spec:hover {\n    background: transparent;\n    border-bottom: 2px solid #ddd;\n}\n\n.product-count {\n    font-size: 12px;\n    opacity: 0.8;\n    font-weight: normal;\n}\n\n/* Responsive adjustments for category popup */\n@media (max-width: 768px) {\n    .category-popup {\n        top: 60px; /* Mobile header height */\n    }\n    \n    .category-grid-container {\n        padding: 0;\n    }\n    \n    .category-grid {\n        padding: 0 10px;\n    }\n    \n    .category-item {\n        min-width: 160px;\n        height: 300px;\n    }\n    \n    .category-content {\n        padding: 20px 15px;\n    }\n    \n    .category-content h3 {\n        font-size: 18px;\n        margin-bottom: 15px;\n    }\n    \n    .category-spec {\n        font-size: 12px;\n        padding: 6px 0;\n    }\n    \n    /* Mobile hover effects */\n    .category-item:active,\n    .category-item.active {\n        background: linear-gradient(135deg, #E84100 0%, #d63900 100%) !important;\n        color: white !important;\n    }\n    \n    .category-item:active .category-label,\n    .category-item.active .category-label {\n        border-bottom: 1px solid rgba(255, 255, 255, 0.3);\n    }\n    \n    .category-item:active .category-spec,\n    .category-item.active .category-spec {\n        color: white;\n        background: transparent;\n        border: none;\n        border-bottom: 2px solid transparent;\n    }\n    \n    .category-item:active .category-spec:active,\n    .category-item.active .category-spec:active {\n        border-bottom: 2px solid white;\n    }\n}\n\n/* Tablet and smaller devices */\n@media (max-width: 1024px) {\n    .top-bar {\n        height: auto;\n        gap: 20px;\n        padding: 20px;\n    }\n\n    .search-container {\n        width: 100%;\n        max-width: 500px;\n    }\n\n    .side-actions {\n        width: 100%;\n        justify-content: space-between;\n    }\n\n    .bottom-nav {\n        padding: 0 20px;\n    }\n\n    .nav-links {\n        gap: 30px;\n    }\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n    .top-bar {\n        justify-content: space-between;\n        align-items: center;\n        height: 60px;\n        padding: 0 15px;\n    }\n\n    .logo-container .logo {\n        height: 24px;\n    }\n\n    .search-container, .side-actions, .bottom-nav {\n        display: none;\n    }\n    \n    .mobile-header-actions {\n        display: flex;\n        align-items: center;\n        gap: 15px;\n    }\n\n    .mobile-header-actions .action-item {\n        min-height: auto;\n        padding: 0;\n        flex-direction: row;\n    }\n\n    .mobile-header-actions .icon-wrapper {\n        width: 24px;\n        height: 24px;\n    }\n\n    .mobile-header-actions .icon-wrapper svg,\n    .mobile-header-actions .icon-wrapper img {\n        width: 24px;\n        height: 24px;\n    }\n\n    .mobile-menu-icon {\n        display: block;\n    }\n    \n    .mobile-menu-icon svg,\n    .more-vert-icon {\n        width: 24px;\n        height: 24px;\n        object-fit: contain;\n    }\n\n    .mobile-nav-menu {\n        display: none;\n    }\n\n    .header-placeholder {\n        height: 60px; /* mobile header height */\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
